<template>
    <b-form-group :label="field.label" :label-for="`id_${field._id}`" :class="{
        'required-field': field.isRequired,
    }">
        <v-select v-model="model" v-validate="{
            required: true,
        }" :options="formatOptions" :maxItem="1000" :disabled="loading || field.disabled"
            :placeholder="field.placeholder" :label="textField" :track-by="valueField" :data-vv-name="field.label" :class="[
                {
                    'is-invalid': errors.has(field.label),
                },
                'form-control padding-form-control-custom '
            ]" :show-no-results="false"></v-select>

        <!--<SearchableDropdown-->
        <!--v-model="model"-->
        <!--v-validate="{-->
        <!--required: true,-->
        <!--}"-->
        <!--:options="formatOptions"-->
        <!--:maxItem="1000"-->
        <!--:disabled="loading || field.disabled"-->
        <!--:placeholder="field.placeholder"-->
        <!--:label="textField"-->
        <!--:track-by="valueField"-->
        <!--:data-vv-name="field.label"-->
        <!--:class="[-->
        <!--{-->
        <!--'is-invalid': errors.has(field.label),-->
        <!--},-->
        <!--]"-->
        <!--:show-no-results="false"-->
        <!--&gt;-->
        <!--</SearchableDropdown>-->
        <!--<multiselect-->
        <!--v-model="model"-->
        <!--v-validate="{-->
        <!--required: true,-->
        <!--}"-->
        <!--:disabled="loading || field.disabled"-->
        <!--:placeholder="field.placeholder"-->
        <!--:options="formatOptions"-->
        <!--:label="textField"-->
        <!--:track-by="valueField"-->
        <!--:multiple="multiple"-->
        <!--:taggable="false"-->
        <!--:data-vv-name="field.label"-->
        <!--:class="[-->
        <!--{-->
        <!--'is-invalid': errors.has(field.label),-->
        <!--},-->
        <!--]"-->
        <!--:show-no-results="false"-->
        <!--&gt;</multiselect>-->
    </b-form-group>
</template>

<script>
import { mapGetters } from 'vuex'

import List from './List.vue'
import Multiselect from 'vue-multiselect'
// import SearchableDropdown from 'vue-simple-search-dropdown';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
    // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        Multiselect,
        // SearchableDropdown,
        vSelect
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        textField: {
            type: String,
            default: 'title',
        },
        valueField: {
            type: String,
            default: 'productId',
        },
        multiple: {
            type: Boolean,
            default: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            options: [],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading']),

        /**
         * format the products list as required
         *
         * @return {void}
         */
        formatOptions() {
            let abc = this.options.map((option) => {
                return {
                    productId: option._id,
                    title: option.title,
                    number: '',
                }
            })
            // console.log('ids code options----', abc)
            return abc
        }, // End of formatOptions() method
    }, // End of Component > computed
}
</script>
<style>
.vs__dropdown-option {
    clear: both;
    color: var(--vs-dropdown-option-color);
    cursor: pointer;
    display: block;
    line-height: 1.42857143;
    padding: var(--vs-dropdown-option-padding);
    white-space: nowrap
}

.vs__dropdown-option--highlight {
    background: purple;
    color: var(--vs-dropdown-option--active-color)
}

.vs__search {}

.vs__search::placeholder {
  color: #9ea0a5;
  font-size: 15px ;
}

.vs__dropdown-menu {
    width: 270px !important;
    /*overflow: auto !important;*/
    border: none !important;
}

.v-select .vs__actions {
    display: none;
}
.vs__selected-options {
    display: contents;
}

/* .vs__search {
    display: none;
} */


.vs__dropdown-toggle {
    position: relative;
    bottom: 10px;
    background: none;
    border: none;
    box-shadow: none;
    font-size: 14px;
    overflow: hidden;
}

.vs__selected {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: var(--vs-selected-bg);
    border: var(--vs-selected-border-width) var(--vs-selected-border-style) var(--vs-selected-border-color);
    border-radius: var(--vs-border-radius);
    color: var(--vs-selected-color);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    line-height: var(--vs-line-height);
    margin: 4px 2px 0;
    padding: 0 0.25em;
    text-wrap: nowrap;
    z-index: 0;
}
.padding-form-control-custom {
    padding: 14px 5px 0px 3px;
}

/*.vs__actions*/
/*{*/
/*display: none !important;*/
/*}*/
</style>